import Vue from 'vue';

export const EventObserver = new Vue();
